<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="订单类型：" class="is-required">
        <el-select v-model="query.orderType" placeholder="请选择" clearable size="small">
          <el-option label="订货订单" :value="1"></el-option>
          <el-option label="积分订单" :value="2"></el-option>
          <el-option label="秒杀订单" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import { filterEmpty } from '@/utils'
export default {
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        orderType: undefined,
      },
    }
  },
  created() {
    this.query.orderType = this.orderType;
  },
  methods: {
    handleDownload() {
      if (!this.query.orderType) return this.$message.warning('请选择订单类型')
      // 订单类型 -1=(就查1和3的数据) 1商城订单 2积分订单 3秒杀订单
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      return this.$common.confirm('是否确认导出')
        .then(() => goodsOrderApi.coustomerOrderReconciliation(filterEmpty(this.query))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },

  }

}
</script>

<style>
</style>